import classNames from 'classnames'
import styles from './FooterCompact.module.css'
import { DefaultLink, LinkItem } from '../shared'
import { Fragment } from 'react/jsx-runtime'
import type { FooterCompactProps } from './types'

function FooterCompact({ text, Link = DefaultLink }: FooterCompactProps) {
  return (
    <footer className={classNames('bp-shared', styles.footer)}>
      {text.providerInfo}
      {text.links.map(({ className, ...linkItemProps }, index) => (
        <Fragment key={index}>
          <LinkItem Link={Link} {...linkItemProps} className={classNames(styles.link, className)} />
        </Fragment>
      ))}
    </footer>
  )
}

export default FooterCompact
